import React from 'react';

const ModalHeaderTitle = ({ children, title }) => (
    <h4>{title || children}</h4>
);

export default ModalHeaderTitle;
